'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _consumer = require('./consumer');

var _consumer2 = _interopRequireDefault(_consumer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _consumer2.default();


// WEBPACK FOOTER //
// ./node_modules/xfc/lib/consumer/index.js